// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"767":"9fa068fc","942":"ee01a0f8"}[chunkId] + ".chunk.css";
};